<script>
var GENRE_OPTIONS = [
  { value: "Pop", id: "genre_pop", label: "Pop" },
  { value: "Rock", id: "genre_rock", label: "Rock" },
  { value: "Ballad", id: "genre_ballad", label: "Ballad" },
  { value: "Hip-Hop", id: "genre_hiphop", label: "Hip-Hop" },
  { value: "R&B", id: "genre_rnb", label: "R&B" },
  { value: "EDM", id: "genre_edm", label: "EDM / Dance" },
  { value: "อื่นๆ", id: "genre_other", label: "อื่นๆ" },
];

var SHARE_FIELDS = [
  "own_perf_share",
  "own_mech_share",
  "own_sync_share",
  "collection_perf_share",
  "collection_mech_share",
  "collection_sync_share",
];

function emptyNameRows() {
  return [{ name: "" }];
}

function emptyForm() {
  return {
    work_id: "",
    iswc: "",
    isrc: "",
    title_local: "",
    title_eng: "",
    lyrics_intro: "",
    song_language: "",
    song_duration: "",
    release_date: "",
    note: "",
  };
}

function emptyTotals() {
  return {
    own_perf_share: 0,
    own_mech_share: 0,
    own_sync_share: 0,
    collection_perf_share: 0,
    collection_mech_share: 0,
    collection_sync_share: 0,
  };
}

export default {
  name: "SongAdd",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      form: emptyForm(),
      artists: emptyNameRows(),
      albums: emptyNameRows(),
      genres: [],
      genreOptions: GENRE_OPTIONS,
      members: [],
      searchQuery: "",
      searchResults: [],
      searchStatus: "",
      searching: false,
      searchTimer: null,
      saving: false,
      alert: { type: "", message: "" },
      audioFile: null,
      videoFile: null,
    };
  },
  computed: {
    listUrl: function () {
      var base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/main-manage-song.php?page=song_list_all";
    },
    genreValue: function () {
      return this.genres.join(", ");
    },
    maxAudioBytes: function () {
      var n = Number((this.config && this.config.maxAudioBytes) || 0);
      return n > 0 ? n : 40 * 1024 * 1024;
    },
    maxVideoBytes: function () {
      var n = Number((this.config && this.config.maxVideoBytes) || 0);
      return n > 0 ? n : 80 * 1024 * 1024;
    },
    displayMembers: function () {
      return this.members.slice().sort(function (a, b) {
        var aIsPublisher = String(a.role_code || "").toUpperCase() === "E";
        var bIsPublisher = String(b.role_code || "").toUpperCase() === "E";
        if (aIsPublisher === bIsPublisher) {
          return 0;
        }
        return aIsPublisher ? 1 : -1;
      });
    },
    shareTotals: function () {
      var totals = emptyTotals();
      var writer = emptyTotals();
      var publisher = emptyTotals();
      var i;
      var item;
      var isPub;
      var bucket;
      var f;
      for (i = 0; i < this.members.length; i++) {
        item = this.members[i];
        isPub = String(item.role_code || "").toUpperCase() === "E";
        bucket = isPub ? publisher : writer;
        for (f = 0; f < SHARE_FIELDS.length; f++) {
          totals[SHARE_FIELDS[f]] += Number(item[SHARE_FIELDS[f]] || 0);
          bucket[SHARE_FIELDS[f]] += Number(item[SHARE_FIELDS[f]] || 0);
        }
      }
      return { totals: totals, writer: writer, publisher: publisher };
    },
    selectedIds: function () {
      var map = {};
      var i;
      for (i = 0; i < this.members.length; i++) {
        map[String(this.members[i].member_id)] = true;
      }
      return map;
    },
    visibleSearchResults: function () {
      var self = this;
      return this.searchResults.filter(function (row) {
        var id = String(row.member_id || "");
        return id !== "" && !self.selectedIds[id];
      });
    },
  },
  beforeUnmount: function () {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  methods: {
    isPublisherType: function (rightsholderType) {
      return /publisher|บริษัทผู้พิมพ์/i.test(String(rightsholderType || ""));
    },
    splitEven: function (total, count) {
      var totalCents;
      var base;
      var remainder;
      var out;
      var i;
      if (count <= 0) {
        return [];
      }
      totalCents = Math.round(Number(total || 0) * 100);
      base = Math.floor(totalCents / count);
      remainder = totalCents - base * count;
      out = [];
      for (i = 0; i < count; i++) {
        out.push((base + (i < remainder ? 1 : 0)) / 100);
      }
      return out;
    },
    setAlert: function (type, message) {
      this.alert = { type: type, message: message || "" };
    },
    onSearchInput: function () {
      var self = this;
      var q = String(this.searchQuery || "").trim();
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      if (q.length < 2) {
        this.searchResults = [];
        this.searchStatus = "";
        this.searching = false;
        return;
      }
      this.searching = true;
      this.searchTimer = setTimeout(function () {
        self.searchMembers(q);
      }, 250);
    },
    searchMembers: function (query) {
      var self = this;
      var api = String((this.config && this.config.searchApi) || "").trim();
      var params = new URLSearchParams();
      params.set("q", query);
      params.set("limit", "20");
      this.searchStatus = "";
      this.searching = true;
      fetch(api + "?" + params.toString(), {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (res) {
          return res.text().then(function (txt) {
            var data = {};
            try {
              data = txt ? JSON.parse(txt) : {};
            } catch (e) {
              data = {};
            }
            if (!res.ok || !data || data.success !== true) {
              throw new Error(data && data.message ? data.message : "ค้นหาสมาชิกไม่สำเร็จ");
            }
            var rows = Array.isArray(data.results) ? data.results : [];
            return rows.map(function (row) {
              return {
                member_id: row.member_id,
                member_code: row.member_code || "",
                internal_no: row.internal_no || "",
                ipi_name_no: row.ipi_name_no || "",
                name_type: row.name_type || "",
                rightsholder_type: row.rightsholder_type || "",
                member_name: row.member_name || row.label || "",
                line: row.line || row.label || row.member_name || "",
              };
            });
          });
        })
        .then(function (rows) {
          self.searchResults = rows;
          self.searchStatus = "";
          self.searching = false;
        })
        .catch(function (err) {
          self.searchResults = [];
          self.searching = false;
          self.searchStatus = err && err.message ? err.message : "ค้นหาสมาชิกไม่สำเร็จ";
        });
    },
    addMember: function (row) {
      var id = Number(row.member_id || 0);
      var exists;
      var i;
      if (id <= 0) {
        return;
      }
      exists = false;
      for (i = 0; i < this.members.length; i++) {
        if (Number(this.members[i].member_id) === id) {
          exists = true;
          break;
        }
      }
      if (!exists) {
        this.members.push({
          member_id: id,
          member_name: String(row.member_name || ""),
          member_code: String(row.member_code || ""),
          line: String(row.line || ""),
          internal_no: String(row.internal_no || ""),
          ipi_name_no: String(row.ipi_name_no || ""),
          name_type: String(row.name_type || ""),
          rightsholder_type: String(row.rightsholder_type || ""),
          role_code: this.isPublisherType(row.rightsholder_type) ? "E" : "C",
          own_perf_share: 0,
          own_mech_share: 0,
          own_sync_share: 0,
          collection_perf_share: 0,
          collection_mech_share: 0,
          collection_sync_share: 0,
        });
      }
      this.searchQuery = "";
      this.searchResults = [];
      this.searchStatus = "";
    },
    removeMember: function (memberId) {
      var id = Number(memberId || 0);
      this.members = this.members.filter(function (it) {
        return Number(it.member_id) !== id;
      });
    },
    onRoleChange: function (item) {
      var selected = String(item.role_code || "C").toUpperCase();
      if (["C", "CA", "A", "AR", "E"].indexOf(selected) === -1) {
        selected = "C";
      }
      item.role_code = selected;
    },
    onShareChange: function (item, field) {
      var val = Number(item[field] || 0);
      if (!isFinite(val) || val < 0) {
        val = 0;
      }
      if (val > 100) {
        val = 100;
      }
      if (String(item.role_code || "").toUpperCase() === "E" && val > 50) {
        val = 50;
        this.setAlert("error", "Publisher (Role E) ใส่ได้ไม่เกิน 50% ต่อช่อง");
      }
      item[field] = Number(val.toFixed(2));
    },
    splitEqual: function () {
      var writerRefs = this.members.slice();
      var publisherRefs;
      var nonPublisherRefs;
      var f;
      var field;
      if (writerRefs.length === 0) {
        this.setAlert("error", "ต้องเลือกสมาชิกก่อนคำนวณหารเท่ากัน");
        return;
      }
      publisherRefs = writerRefs.filter(function (item) {
        return String(item.role_code || "").toUpperCase() === "E";
      });
      nonPublisherRefs = writerRefs.filter(function (item) {
        return String(item.role_code || "").toUpperCase() !== "E";
      });
      for (f = 0; f < SHARE_FIELDS.length; f++) {
        field = SHARE_FIELDS[f];
        if (publisherRefs.length > 0) {
          var publisherSplit = this.splitEven(50, publisherRefs.length);
          var nonPublisherSplit = this.splitEven(50, nonPublisherRefs.length);
          publisherRefs.forEach(function (item, idx) {
            item[field] = publisherSplit[idx] || 0;
          });
          nonPublisherRefs.forEach(function (item, idx) {
            item[field] = nonPublisherSplit[idx] || 0;
          });
        } else {
          var writerSplit = this.splitEven(100, writerRefs.length);
          writerRefs.forEach(function (item, idx) {
            item[field] = writerSplit[idx] || 0;
          });
        }
      }
      if (publisherRefs.length > 0) {
        this.setAlert("success", "คำนวณหารเท่ากันเรียบร้อย (Publisher รวม 50% เสมอ)");
      } else {
        this.setAlert("success", "คำนวณหารเท่ากันเรียบร้อย (นักแต่งรวม 100%)");
      }
    },
    mockTest: function () {
      var now = new Date();
      var yyyy = now.getFullYear();
      var mm = String(now.getMonth() + 1).padStart(2, "0");
      var dd = String(now.getDate()).padStart(2, "0");
      var seed = String(now.getTime()).slice(-6);
      this.form = {
        work_id: "TEST-WORK-" + seed,
        iswc: "T-" + seed + ".123.456-0",
        isrc: "TH-AAA-26-" + seed,
        title_local: "เพลงทดสอบระบบ " + seed,
        title_eng: "System Test Song " + seed,
        lyrics_intro: "นี่คือบรรทัดแรกของเพลงทดสอบ",
        song_language: "ไทย",
        song_duration: "215",
        release_date: yyyy + "-" + mm + "-" + dd,
        note: "ข้อมูลนี้สร้างจากปุ่มจำลอง (Test)",
      };
      this.artists = [{ name: "ศิลปินทดสอบ A" }, { name: "ศิลปินทดสอบ B" }];
      this.albums = [{ name: "อัลบั้มทดสอบ 1" }, { name: "อัลบั้มทดสอบ 2" }];
      this.genres = ["Pop", "Rock"];
      this.setAlert("success", "เติมข้อมูลตัวอย่างเรียบร้อย (ยังไม่ได้บันทึก)");
    },
    sumByType: function (items, key) {
      var total = 0;
      var i;
      var n;
      for (i = 0; i < items.length; i++) {
        n = Number(items[i][key] || 0);
        if (!isFinite(n) || n < 0 || n > 100) {
          return NaN;
        }
        total += n;
      }
      return total;
    },
    rolePayloads: function () {
      var base = this.members.map(function (it) {
        var role = String(it.role_code || "C").toUpperCase();
        if (["C", "CA", "A", "AR", "E"].indexOf(role) === -1) {
          role = "C";
        }
        return {
          member_id: Number(it.member_id),
          role_code: role,
          own_perf_share: Number(it.own_perf_share || 0),
          own_mech_share: Number(it.own_mech_share || 0),
          own_sync_share: Number(it.own_sync_share || 0),
          collection_perf_share: Number(it.collection_perf_share || 0),
          collection_mech_share: Number(it.collection_mech_share || 0),
          collection_sync_share: Number(it.collection_sync_share || 0),
        };
      });
      return {
        melody_member_shares: base.filter(function (it) {
          return it.role_code === "C" || it.role_code === "CA";
        }),
        lyrics_member_shares: base.filter(function (it) {
          return it.role_code === "A";
        }),
        arrangement_member_shares: base.filter(function (it) {
          return it.role_code === "AR";
        }),
        publisher_member_shares: base.filter(function (it) {
          return it.role_code === "E";
        }),
      };
    },
    resetForm: function () {
      this.form = emptyForm();
      this.artists = emptyNameRows();
      this.albums = emptyNameRows();
      this.genres = [];
      this.members = [];
      this.searchQuery = "";
      this.searchResults = [];
      this.searchStatus = "";
      this.searching = false;
      this.clearMedia("audio");
      this.clearMedia("video");
    },
    formatBytes: function (bytes) {
      var n = Number(bytes || 0);
      if (!isFinite(n) || n <= 0) {
        return "0 B";
      }
      if (n < 1024) {
        return String(n) + " B";
      }
      if (n < 1024 * 1024) {
        return (n / 1024).toFixed(1) + " KB";
      }
      return (n / (1024 * 1024)).toFixed(1) + " MB";
    },
    onMediaPicked: function (kind, event) {
      var files = event && event.target && event.target.files ? event.target.files : null;
      var file = files && files[0] ? files[0] : null;
      var name;
      var maxBytes;
      var label;
      if (!file) {
        return;
      }
      name = String(file.name || "").toLowerCase();
      if (kind === "video") {
        maxBytes = this.maxVideoBytes;
        label = "MP4";
        if (!/\.mp4$/i.test(name)) {
          this.setAlert("error", "ไฟล์วิดีโอต้องเป็น MP4 เท่านั้น");
          event.target.value = "";
          return;
        }
        if (file.size > maxBytes) {
          this.setAlert("error", "ไฟล์ MP4 ต้องไม่เกิน " + this.formatBytes(maxBytes));
          event.target.value = "";
          return;
        }
        this.videoFile = file;
      } else {
        maxBytes = this.maxAudioBytes;
        label = "MP3";
        if (!/\.mp3$/i.test(name)) {
          this.setAlert("error", "ไฟล์เสียงต้องเป็น MP3 เท่านั้น");
          event.target.value = "";
          return;
        }
        if (file.size > maxBytes) {
          this.setAlert("error", "ไฟล์ MP3 ต้องไม่เกิน " + this.formatBytes(maxBytes));
          event.target.value = "";
          return;
        }
        this.audioFile = file;
      }
      this.setAlert("", "");
    },
    clearMedia: function (kind) {
      var input;
      if (kind === "video") {
        this.videoFile = null;
        input = this.$refs.videoFileInput;
      } else {
        this.audioFile = null;
        input = this.$refs.audioFileInput;
      }
      if (input) {
        input.value = "";
      }
    },
    collectNameRows: function (rows) {
      var out = [];
      var seen = {};
      (Array.isArray(rows) ? rows : []).forEach(function (row) {
        var name = String(row && row.name ? row.name : "").trim();
        var key;
        if (name === "") {
          return;
        }
        key = name.toLowerCase();
        if (seen[key]) {
          return;
        }
        seen[key] = true;
        out.push(name);
      });
      return out;
    },
    addNameRow: function (kind) {
      var list = kind === "album" ? this.albums : this.artists;
      list.push({ name: "" });
    },
    removeNameRow: function (kind, index) {
      var list = kind === "album" ? this.albums : this.artists;
      if (list.length <= 1) {
        list[0].name = "";
        return;
      }
      list.splice(index, 1);
    },
    saveSong: function () {
      var self = this;
      var createApi = String((this.config && this.config.createApi) || "").trim();
      var payloads = this.rolePayloads();
      var writerOwnPerf =
        this.sumByType(payloads.melody_member_shares, "own_perf_share") +
        this.sumByType(payloads.lyrics_member_shares, "own_perf_share") +
        this.sumByType(payloads.arrangement_member_shares, "own_perf_share");
      var writerOwnMech =
        this.sumByType(payloads.melody_member_shares, "own_mech_share") +
        this.sumByType(payloads.lyrics_member_shares, "own_mech_share") +
        this.sumByType(payloads.arrangement_member_shares, "own_mech_share");
      var writerOwnSync =
        this.sumByType(payloads.melody_member_shares, "own_sync_share") +
        this.sumByType(payloads.lyrics_member_shares, "own_sync_share") +
        this.sumByType(payloads.arrangement_member_shares, "own_sync_share");
      var writerCollectionPerf =
        this.sumByType(payloads.melody_member_shares, "collection_perf_share") +
        this.sumByType(payloads.lyrics_member_shares, "collection_perf_share") +
        this.sumByType(payloads.arrangement_member_shares, "collection_perf_share");
      var writerCollectionMech =
        this.sumByType(payloads.melody_member_shares, "collection_mech_share") +
        this.sumByType(payloads.lyrics_member_shares, "collection_mech_share") +
        this.sumByType(payloads.arrangement_member_shares, "collection_mech_share");
      var writerCollectionSync =
        this.sumByType(payloads.melody_member_shares, "collection_sync_share") +
        this.sumByType(payloads.lyrics_member_shares, "collection_sync_share") +
        this.sumByType(payloads.arrangement_member_shares, "collection_sync_share");
      var publisherOwnPerf = this.sumByType(payloads.publisher_member_shares, "own_perf_share");
      var publisherOwnMech = this.sumByType(payloads.publisher_member_shares, "own_mech_share");
      var publisherOwnSync = this.sumByType(payloads.publisher_member_shares, "own_sync_share");
      var publisherCollectionPerf = this.sumByType(payloads.publisher_member_shares, "collection_perf_share");
      var publisherCollectionMech = this.sumByType(payloads.publisher_member_shares, "collection_mech_share");
      var publisherCollectionSync = this.sumByType(payloads.publisher_member_shares, "collection_sync_share");
      var checks = [
        writerOwnPerf,
        writerOwnMech,
        writerOwnSync,
        writerCollectionPerf,
        writerCollectionMech,
        writerCollectionSync,
        publisherOwnPerf,
        publisherOwnMech,
        publisherOwnSync,
        publisherCollectionPerf,
        publisherCollectionMech,
        publisherCollectionSync,
      ];
      var payload;
      this.alert = { type: "", message: "" };
      if (
        checks.some(function (v) {
          return !isFinite(v);
        })
      ) {
        this.setAlert("error", "ค่าเปอร์เซ็นต์แชร์ต้องอยู่ในช่วง 0-100");
        return;
      }
      if (
        publisherOwnPerf > 50.01 ||
        publisherOwnMech > 50.01 ||
        publisherOwnSync > 50.01 ||
        publisherCollectionPerf > 50.01 ||
        publisherCollectionMech > 50.01 ||
        publisherCollectionSync > 50.01
      ) {
        this.setAlert("error", "Publisher รวมกันต้องไม่เกิน 50% ในทุกช่องแชร์");
        return;
      }
      if (
        Math.abs(writerOwnPerf + publisherOwnPerf - 100) > 0.01 ||
        Math.abs(writerOwnMech + publisherOwnMech - 100) > 0.01 ||
        Math.abs(writerOwnSync + publisherOwnSync - 100) > 0.01 ||
        Math.abs(writerCollectionPerf + publisherCollectionPerf - 100) > 0.01 ||
        Math.abs(writerCollectionMech + publisherCollectionMech - 100) > 0.01 ||
        Math.abs(writerCollectionSync + publisherCollectionSync - 100) > 0.01
      ) {
        this.setAlert("error", "ผลรวมนักแต่ง + Publisher ต้องเท่ากับ 100% ในทุกช่องแชร์");
        return;
      }
      payload = {
        work_id: String(this.form.work_id || "").trim(),
        title_local: String(this.form.title_local || "").trim(),
        title_eng: String(this.form.title_eng || "").trim(),
        song_language: String(this.form.song_language || "").trim(),
        genre: this.genreValue,
        sub_genre: "",
        song_duration: Number(this.form.song_duration || 0),
        bpm: 0,
        release_date: String(this.form.release_date || "").trim(),
        copyright_year: 0,
        artists: this.collectNameRows(this.artists),
        albums: this.collectNameRows(this.albums),
        artist_name: this.collectNameRows(this.artists).join("\n"),
        album_name: this.collectNameRows(this.albums).join("\n"),
        lyrics_intro: String(this.form.lyrics_intro || "").trim(),
        iswc: String(this.form.iswc || "").trim(),
        isrc: String(this.form.isrc || "").trim(),
        note: String(this.form.note || "").trim(),
        melody_member_shares: payloads.melody_member_shares,
        lyrics_member_shares: payloads.lyrics_member_shares,
        arrangement_member_shares: payloads.arrangement_member_shares,
        publisher_member_shares: payloads.publisher_member_shares,
      };
      if (payload.work_id === "") {
        this.setAlert("error", "กรุณากรอก Work ID");
        return;
      }
      if (createApi === "") {
        this.setAlert("error", "ไม่พบที่อยู่ API บันทึกเพลง");
        return;
      }
      if (this.audioFile && this.audioFile.size > this.maxAudioBytes) {
        this.setAlert("error", "ไฟล์ MP3 ต้องไม่เกิน " + this.formatBytes(this.maxAudioBytes));
        return;
      }
      if (this.videoFile && this.videoFile.size > this.maxVideoBytes) {
        this.setAlert("error", "ไฟล์ MP4 ต้องไม่เกิน " + this.formatBytes(this.maxVideoBytes));
        return;
      }
      this.saving = true;
      var formData = new FormData();
      formData.append("payload", JSON.stringify(payload));
      if (this.audioFile) {
        formData.append("audio_file", this.audioFile, this.audioFile.name);
      }
      if (this.videoFile) {
        formData.append("video_file", this.videoFile, this.videoFile.name);
      }
      fetch(createApi, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: formData,
      })
        .then(function (res) {
          return res.text().then(function (txt) {
            var data = {};
            try {
              data = txt ? JSON.parse(txt) : {};
            } catch (e) {
              throw new Error("API ตอบกลับไม่ถูกต้อง");
            }
            return { ok: res.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok || !res.data || res.data.success !== true) {
            throw new Error(res.data && res.data.message ? res.data.message : "ไม่สามารถบันทึกข้อมูลเพลงได้");
          }
          self.resetForm();
          self.setAlert("success", "บันทึกข้อมูลเพลงสำเร็จ");
        })
        .catch(function (err) {
          self.setAlert("error", err.message || "เกิดข้อผิดพลาดในการบันทึกข้อมูลเพลง");
        })
        .finally(function () {
          self.saving = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">เพิ่มข้อมูลเพลง</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">จัดการเพลง</a></li>
              <li class="breadcrumb-item"><a :href="listUrl">รายการเพลงทั้งหมด</a></li>
              <li class="breadcrumb-item active">เพิ่มเพลง</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="alert.message" class="alert alert-dismissible fade show" :class="alert.type === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
      {{ alert.message }}
      <button type="button" class="btn-close" aria-label="ปิด" @click="alert.message = ''"></button>
    </div>

    <div class="card">
      <div class="card-body">
        <form novalidate @submit.prevent="saveSong">
          <div class="row g-3">
            <div class="col-12">
              <div class="song-form-section">
                <div class="song-form-section-title">ข้อมูลระบุผลงาน (Work Identification)</div>
                <div class="row g-3">
                  <div class="col-md-4">
                    <label class="form-label" for="work_id">Work ID <span class="text-danger">*</span></label>
                    <input id="work_id" v-model="form.work_id" type="text" class="form-control" maxlength="80" required>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="iswc">ISWC</label>
                    <input id="iswc" v-model="form.iswc" type="text" class="form-control" maxlength="32">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="isrc">ISRC</label>
                    <input id="isrc" v-model="form.isrc" type="text" class="form-control" maxlength="32">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="song-form-section">
                <div class="song-form-section-title">รายละเอียดตัวเพลง (Song Metadata)</div>
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label" for="title_local">ชื่อเพลง (ไทย)</label>
                    <input id="title_local" v-model="form.title_local" type="text" class="form-control" maxlength="300">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label" for="title_eng">ชื่อเพลง (อังกฤษ)</label>
                    <input id="title_eng" v-model="form.title_eng" type="text" class="form-control" maxlength="300">
                  </div>
                  <div class="col-md-12">
                    <label class="form-label" for="lyrics_intro">เนื้อร้องขึ้นต้น</label>
                    <input id="lyrics_intro" v-model="form.lyrics_intro" type="text" class="form-control" maxlength="300" placeholder="1–2 บรรทัดแรกของเนื้อเพลง">
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
                      <label class="form-label mb-0">ศิลปิน</label>
                      <button type="button" class="btn btn-sm btn-soft-primary" @click="addNameRow('artist')">
                        <i class="ri-add-line align-middle"></i> เพิ่มแถว
                      </button>
                    </div>
                    <div v-for="(row, idx) in artists" :key="'artist-' + idx" class="song-name-row">
                      <input v-model="row.name" type="text" class="form-control" maxlength="200" :placeholder="'ศิลปินแถวที่ ' + (idx + 1)">
                      <button type="button" class="btn btn-sm btn-soft-danger" :disabled="artists.length === 1 && !row.name" @click="removeNameRow('artist', idx)" title="ลบแถว">
                        <i class="ri-delete-bin-line"></i>
                      </button>
                    </div>
                    <div class="song-form-helper">ระบุได้หลายคน คนละแถว</div>
                  </div>
                  <div class="col-md-6">
                    <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
                      <label class="form-label mb-0">อัลบั้ม</label>
                      <button type="button" class="btn btn-sm btn-soft-primary" @click="addNameRow('album')">
                        <i class="ri-add-line align-middle"></i> เพิ่มแถว
                      </button>
                    </div>
                    <div v-for="(row, idx) in albums" :key="'album-' + idx" class="song-name-row">
                      <input v-model="row.name" type="text" class="form-control" maxlength="200" :placeholder="'อัลบั้มแถวที่ ' + (idx + 1)">
                      <button type="button" class="btn btn-sm btn-soft-danger" :disabled="albums.length === 1 && !row.name" @click="removeNameRow('album', idx)" title="ลบแถว">
                        <i class="ri-delete-bin-line"></i>
                      </button>
                    </div>
                    <div class="song-form-helper">ระบุได้หลายอัลบั้ม อัลบั้มละแถว</div>
                  </div>
                  <div class="col-md-12">
                    <label class="form-label">แนวเพลง (Genre)</label>
                    <div class="song-genre-box">
                      <div v-for="opt in genreOptions" :key="opt.value" class="form-check">
                        <input :id="opt.id" v-model="genres" class="form-check-input" type="checkbox" :value="opt.value">
                        <label class="form-check-label" :for="opt.id">{{ opt.label }}</label>
                      </div>
                    </div>
                    <div class="song-form-helper">เลือกได้หลายข้อ ระบบจะรวมค่าอัตโนมัติ</div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="song_language">ภาษาเพลง</label>
                    <input id="song_language" v-model="form.song_language" type="text" class="form-control" maxlength="80" placeholder="เช่น ไทย, อังกฤษ">
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="song_duration">ความยาวเพลง (วินาที)</label>
                    <input id="song_duration" v-model="form.song_duration" type="number" class="form-control" min="0" step="1" placeholder="เช่น 215">
                  </div>
                  <div class="col-md-3">
                    <label class="form-label" for="release_date">วันที่เผยแพร่</label>
                    <input id="release_date" v-model="form.release_date" type="date" class="form-control">
                  </div>
                  <div class="col-12">
                    <label class="form-label" for="note">หมายเหตุ</label>
                    <textarea id="note" v-model="form.note" class="form-control" rows="2" maxlength="500" placeholder="รายละเอียดเพิ่มเติมของเพลง"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="song-form-section">
                <div class="song-form-section-title">ไฟล์เพลง (MP3 / MP4)</div>
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label">ไฟล์เสียง MP3</label>
                    <input ref="audioFileInput" type="file" class="form-control" accept=".mp3,audio/mpeg" @change="onMediaPicked('audio', $event)">
                    <div v-if="audioFile" class="song-file-picked">
                      <span>{{ audioFile.name }} ({{ formatBytes(audioFile.size) }})</span>
                      <button type="button" class="btn btn-sm btn-soft-danger" @click="clearMedia('audio')">ลบไฟล์</button>
                    </div>
                    <div class="song-form-helper">อัปโหลดได้ 1 ไฟล์ ไม่เกิน {{ formatBytes(maxAudioBytes) }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">ไฟล์วิดีโอ MP4</label>
                    <input ref="videoFileInput" type="file" class="form-control" accept=".mp4,video/mp4" @change="onMediaPicked('video', $event)">
                    <div v-if="videoFile" class="song-file-picked">
                      <span>{{ videoFile.name }} ({{ formatBytes(videoFile.size) }})</span>
                      <button type="button" class="btn btn-sm btn-soft-danger" @click="clearMedia('video')">ลบไฟล์</button>
                    </div>
                    <div class="song-form-helper">อัปโหลดได้ 1 ไฟล์ ไม่เกิน {{ formatBytes(maxVideoBytes) }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="song-form-section">
                <div class="song-form-section-title">สมาชิกนักแต่ง / Publisher และสัดส่วน Share</div>
                <label class="form-label">ค้นหา สมาชิกนักแต่ง/Publisher</label>
                <div class="song-member-picker role-melody">
                  <input
                    v-model="searchQuery"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหา สมาชิกนักแต่ง/Publisher (อย่างน้อย 2 ตัวอักษร)"
                    autocomplete="off"
                    @input="onSearchInput"
                  >
                  <div class="list-group mt-2">
                    <div v-if="searchStatus" class="list-group-item text-danger small">{{ searchStatus }}</div>
                    <div v-else-if="searching" class="list-group-item text-muted small">กำลังค้นหา...</div>
                    <div v-else-if="searchQuery.trim().length >= 2 && searchResults.length && visibleSearchResults.length === 0" class="list-group-item text-muted small">สมาชิกนี้ถูกเลือกแล้ว</div>
                    <div v-else-if="searchQuery.trim().length >= 2 && searchResults.length === 0" class="list-group-item text-muted small">ไม่พบสมาชิก</div>
                    <button
                      v-for="row in visibleSearchResults"
                      :key="row.member_id"
                      type="button"
                      class="list-group-item list-group-item-action"
                      @click="addMember(row)"
                    >
                      {{ row.line || row.member_name || row.member_id }}
                    </button>
                  </div>
                  <div class="mt-2">
                    <span v-if="!displayMembers.length" class="text-muted small">ยังไม่ได้เลือกสมาชิก</span>
                    <template v-else>
                      <div class="table-responsive song-share-grid">
                        <table class="table table-sm table-bordered align-middle">
                          <thead class="song-table-head-melody">
                            <tr>
                              <th rowspan="2" style="width:120px; text-align: center;">Internal No</th>
                              <th rowspan="2" style="text-align: center;">IPI Name No</th>
                              <th rowspan="2" style="min-width:220px; text-align: center;">Name</th>
                              <th rowspan="2" style="width:90px; text-align: center;">Type</th>
                              <th rowspan="2" style="width:90px; text-align: center;">Role</th>
                              <th colspan="3" class="text-center">Own</th>
                              <th colspan="3" class="text-center">Collection</th>
                              <th rowspan="2" style="width:80px; text-align: center;">ลบ</th>
                            </tr>
                            <tr>
                              <th style="width:120px">Perf %</th>
                              <th style="width:120px">Mech %</th>
                              <th style="width:120px">Sync %</th>
                              <th style="width:120px">Perf %</th>
                              <th style="width:120px">Mech %</th>
                              <th style="width:120px">Sync %</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in displayMembers" :key="item.member_id">
                              <td style="text-align: center;">{{ item.internal_no || "-" }}</td>
                              <td style="text-align: center;">{{ item.ipi_name_no || "-" }}</td>
                              <td>{{ item.member_name || ("ID:" + item.member_id) }}</td>
                              <td><span class="d-inline-block w-100 text-center">{{ item.name_type || "PA" }}</span></td>
                              <td style="text-align: center;">
                                <span v-if="isPublisherType(item.rightsholder_type)" class="song-share-role-badge">E</span>
                                <select v-else v-model="item.role_code" class="form-select form-select-sm song-role-select" @change="onRoleChange(item)">
                                  <option value="C">C</option>
                                  <option value="CA">CA</option>
                                  <option value="A">A</option>
                                  <option value="AR">AR</option>
                                  <option value="E">E</option>
                                </select>
                              </td>
                              <td><input v-model.number="item.own_perf_share" type="number" min="0" max="100" step="0.01" class="form-control form-control-sm song-share-input" @change="onShareChange(item, 'own_perf_share')"></td>
                              <td><input v-model.number="item.own_mech_share" type="number" min="0" max="100" step="0.01" class="form-control form-control-sm song-share-input" @change="onShareChange(item, 'own_mech_share')"></td>
                              <td><input v-model.number="item.own_sync_share" type="number" min="0" max="100" step="0.01" class="form-control form-control-sm song-share-input" @change="onShareChange(item, 'own_sync_share')"></td>
                              <td><input v-model.number="item.collection_perf_share" type="number" min="0" max="100" step="0.01" class="form-control form-control-sm song-share-input" @change="onShareChange(item, 'collection_perf_share')"></td>
                              <td><input v-model.number="item.collection_mech_share" type="number" min="0" max="100" step="0.01" class="form-control form-control-sm song-share-input" @change="onShareChange(item, 'collection_mech_share')"></td>
                              <td><input v-model.number="item.collection_sync_share" type="number" min="0" max="100" step="0.01" class="form-control form-control-sm song-share-input" @change="onShareChange(item, 'collection_sync_share')"></td>
                              <td class="text-center">
                                <button type="button" class="btn btn-sm btn-soft-danger" @click="removeMember(item.member_id)">ลบ</button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="song-share-summary-wrap">
                        <table class="table table-sm song-share-summary-table">
                          <thead><tr><th colspan="2">สรุปผลรวม Share</th></tr></thead>
                          <tbody>
                            <tr><td>รวม Own Perf</td><td>{{ shareTotals.totals.own_perf_share.toFixed(2) }}%</td></tr>
                            <tr><td>Own Mech</td><td>{{ shareTotals.totals.own_mech_share.toFixed(2) }}%</td></tr>
                            <tr><td>Own Sync</td><td>{{ shareTotals.totals.own_sync_share.toFixed(2) }}%</td></tr>
                            <tr><td>Col Perf</td><td>{{ shareTotals.totals.collection_perf_share.toFixed(2) }}%</td></tr>
                            <tr><td>Col Mech</td><td>{{ shareTotals.totals.collection_mech_share.toFixed(2) }}%</td></tr>
                            <tr><td>Col Sync</td><td>{{ shareTotals.totals.collection_sync_share.toFixed(2) }}%</td></tr>
                            <tr class="table-light">
                              <td><strong>Writers Total</strong></td>
                              <td><strong>{{ shareTotals.writer.own_perf_share.toFixed(2) }}% / {{ shareTotals.writer.own_mech_share.toFixed(2) }}% / {{ shareTotals.writer.own_sync_share.toFixed(2) }}%</strong></td>
                            </tr>
                            <tr class="table-light">
                              <td><strong>Publishers Total</strong></td>
                              <td><strong>{{ shareTotals.publisher.own_perf_share.toFixed(2) }}% / {{ shareTotals.publisher.own_mech_share.toFixed(2) }}% / {{ shareTotals.publisher.own_sync_share.toFixed(2) }}%</strong></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4 d-flex flex-wrap gap-2">
            <button type="button" class="btn btn-soft-info" @click="mockTest">จำลอง (Test)</button>
            <button type="button" class="btn btn-soft-primary" @click="splitEqual">คำนวณหารเท่ากัน</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">{{ saving ? "กำลังบันทึก..." : "บันทึกข้อมูลเพลง" }}</button>
            <a :href="listUrl" class="btn btn-light">กลับไปรายการเพลง</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style>
.song-member-picker {
  border: 1px solid #e9ebec;
  border-radius: 0.5rem;
  padding: 0.9rem;
  background: #fff;
}
.song-member-picker.role-melody {
  border-color: #8ec5ff;
  background: #f4f9ff;
}
.song-table-head-melody th {
  background: #e9f3ff !important;
}
.song-share-grid {
  border: 1px solid #dbeafe;
  border-radius: 0.85rem;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}
.song-share-grid .table {
  margin-bottom: 0;
  background: #ffffff;
}
.song-share-grid thead th {
  vertical-align: middle;
  font-size: 0.78rem;
  letter-spacing: 0.01em;
  border-color: #dbeafe !important;
}
.song-share-grid thead tr:first-child th {
  background: #eaf2ff !important;
  color: #1e3a8a;
  font-weight: 700;
}
.song-share-grid thead tr:nth-child(2) th {
  background: #f7fbff !important;
  color: #334155;
  font-weight: 600;
}
.song-share-grid tbody tr:nth-child(odd) {
  background: #fcfdff;
}
.song-share-grid td {
  border-color: #e2e8f0 !important;
  vertical-align: middle;
  font-size: 0.82rem;
}
.song-share-grid .song-share-input {
  text-align: right;
  min-width: 92px;
  border-radius: 0.45rem;
  border-color: #cbd5e1;
  background: #fff;
}
.song-share-role-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.72rem;
  background: #f1f5f9;
  color: #334155;
  border: 1px solid #cbd5e1;
}
.song-share-grid .song-role-select {
  border-radius: 0.45rem;
  min-width: 80px;
}
.song-share-summary-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.song-share-summary-table {
  width: 100%;
  max-width: 380px;
  margin-bottom: 0;
  background: #f9fbff;
  border: 1px solid #d0e4ff;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
}
.song-share-summary-table thead th {
  background: linear-gradient(90deg, #e0f2ff 0%, #f3f8ff 100%);
  text-align: center;
  font-size: 0.85rem;
  color: #1d4ed8;
}
.song-share-summary-table td {
  font-size: 0.85rem;
  vertical-align: middle;
}
.song-share-summary-table td:last-child {
  text-align: right;
  font-weight: 600;
}
.song-form-section {
  border: 1px solid #dbeafe;
  border-radius: 0.9rem;
  padding: 1.05rem 1.1rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 60%, #f3f6ff 100%);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.03);
}
.song-form-section + .song-form-section {
  margin-top: 0.75rem;
}
.song-form-section-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: #1d4ed8;
  margin-bottom: 0.85rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px dashed rgba(37, 99, 235, 0.25);
}
.song-form-helper {
  font-size: 0.8rem;
  color: #667085;
  margin-top: 0.25rem;
}
.song-file-picked {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.45rem 0.65rem;
  border: 1px solid #dbeafe;
  border-radius: 0.6rem;
  background: #f8fbff;
  font-size: 0.82rem;
  color: #1e3a8a;
}
.song-name-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.song-name-row .form-control {
  flex: 1 1 auto;
}
.song-genre-box {
  border: 1px solid #c7d2fe;
  border-radius: 0.75rem;
  padding: 0.65rem 0.8rem;
  background: radial-gradient(circle at top left, #eef2ff 0%, #f9fafb 55%, #ffffff 100%);
  min-height: 140px;
  columns: 2;
}
.song-genre-box .form-check-input:checked {
  background-color: #2563eb;
  border-color: #2563eb;
}
.song-genre-box .form-check-label {
  font-size: 0.85rem;
}
.song-genre-box .form-check {
  break-inside: avoid;
  margin-bottom: 0.3rem;
}
</style>
